export const resolveOnNoContent = ({ response }) => (response.status === 204
  ? Promise.resolve({
    ...response,
    async json() {
      return '';
    }
  })
  : Promise.resolve(response));
